import React from "react";
import pricing_structure from "../../images/pricing_structure.png";
import useWindowDimensions from "../../components/getWindowDimensions";

function PricingStructure() {
  const { width } = useWindowDimensions();
  const imageWidth = width < 1060 ? "95%" : "70%";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "30px 20px 100px 20px",
      }}
    >
      <img
        src={pricing_structure}
        alt="Pricing Structure"
        style={{ maxWidth: "100%", height: "auto", width: imageWidth }}
      />
    </div>
  );
}

export default PricingStructure;
